(() => {
  if (customElements.get('tt-legacy-gift-bags')) return;
  class TTLegacyGiftBags extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-gift-open]');
      this.submit = this.querySelector('[data-gift-submit]');
      this.widget = this.querySelector('tt-gift-bag');
      this.chooser = this.querySelector('[data-gift-chooser]');
      this.result = this.querySelector('[data-gift-result]');
      this.cartLink = this.querySelector('[data-gift-cart]');
      if (!this.dialog || !this.opener || !this.submit || !this.widget || typeof this.dialog.showModal !== 'function') return;
      this.initialized = true;
      this.submitLabel = this.submit.textContent;
      this.opener.hidden = false;
      this.opener.addEventListener('click', () => {
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
      });
      this.querySelector('[data-gift-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.focus();
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.addEventListener('tt:gift-bag-change', () => this.refresh());
      this.submit.addEventListener('click', () => this.addBags());
      this.refresh();
    }
    selections() {
      return typeof this.widget.getSelections === 'function' ? this.widget.getSelections().filter(bag => Number.isSafeInteger(Number(bag.id)) && Number(bag.id) > 0 && Number.isSafeInteger(Number(bag.quantity)) && Number(bag.quantity) > 0 && Number(bag.quantity) <= 99) : [];
    }
    refresh() {
      this.submit.disabled = Boolean(this.busy) || this.selections().length === 0;
      const variant = this.widget.querySelector('[data-tt-gift-variant][aria-checked="true"]');
      if (!variant) return;
      const price = this.opener.querySelector('[data-gift-preview-price]');
      const compare = this.opener.querySelector('[data-gift-preview-compare]');
      const photo = this.opener.querySelector('[data-gift-preview-photo]');
      if (price) price.textContent = variant.dataset.ttGiftMoney;
      if (compare) {
        compare.textContent = variant.dataset.ttGiftCompareMoney;
        compare.hidden = Number(variant.dataset.ttGiftCompareValue) <= Number(variant.dataset.ttGiftPriceValue);
      }
      if (photo) {
        let image = photo.querySelector('img');
        if (variant.dataset.ttGiftImage) {
          if (!image) {
            image = document.createElement('img');
            image.width = 52;
            image.height = 52;
            image.loading = 'lazy';
            photo.appendChild(image);
          }
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = variant.dataset.ttGiftImage;
          image.alt = variant.dataset.ttGiftSizeValue + ' / ' + variant.dataset.ttGiftName;
          image.hidden = false;
        } else if (image) image.hidden = true;
      }
    }
    async addBags() {
      if (this.busy) return;
      const bags = this.selections();
      if (!bags.length) return;
      this.busy = true;
      this.chooser.disabled = true;
      this.submit.textContent = this.dataset.adding;
      this.result.textContent = '';
      this.cartLink.hidden = true;
      this.refresh();
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: bags.map(bag => ({ id: Number(bag.id), quantity: Number(bag.quantity) })) })
        });
        if (!response.ok) throw new Error('Gift bag cart request failed');
        bags.forEach(bag => this.widget.changeQuantity(String(bag.id), -Number(bag.quantity)));
        this.result.textContent = this.dataset.success;
        this.cartLink.hidden = false;
        this.result.focus();
        this.dispatchEvent(new CustomEvent('tt:gift-bags-added', { bubbles: true, detail: { items: bags.map(bag => ({ id: Number(bag.id), quantity: Number(bag.quantity) })) } }));
      } catch (error) {
        this.result.textContent = this.dataset.error;
        this.result.focus();
      } finally {
        this.busy = false;
        this.chooser.disabled = false;
        this.submit.textContent = this.submitLabel;
        this.refresh();
      }
    }
  }
  customElements.define('tt-legacy-gift-bags', TTLegacyGiftBags);
})();
